import React from 'react';

function Button({ isLoading, children, className = '', ...props }) {
  return (
    <button className={`btn btn-primary ${className}`} type="submit" disabled={isLoading} {...props}>
      {isLoading ? (
        <span className="loading loading-dots loading-sm"></span>
      ) : (
        children
      )}
    </button>
  );
}

export default Button;